module.exports = __webpack_public_path__ + "img/img_level_11.e0670332.png";